import { L2_CHAIN_IDS } from '../../../../../constants/chains';
import { DEFAULT_DEADLINE_FROM_NOW, L2_DEADLINE_FROM_NOW } from '../../../../../constants/misc';
/** Returns the default transaction TTL for the chain, in minutes. */
export function getDefaultTransactionTtl(_a) {
    var chainId = _a.chainId;
    if (chainId && L2_CHAIN_IDS.includes(chainId))
        return L2_DEADLINE_FROM_NOW / 60;
    return DEFAULT_DEADLINE_FROM_NOW / 60;
}
// combines the block timestamp with the user setting to give the deadline that should be used for any submitted transaction
export default function getTransactionDeadline(_a) {
    var chainId = _a.chainId, blockTimestamp = _a.blockTimestamp;
    var defaultTtl = getDefaultTransactionTtl({ chainId: chainId });
    //const blockTimestamp = useCurrentBlockTimestamp()
    return blockTimestamp === null || blockTimestamp === void 0 ? void 0 : blockTimestamp.add(defaultTtl /* in seconds */ * 60);
}
